"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePeriod = void 0;
const get_number_of_days_1 = require("./get-number-of-days");
const ONE_DAY = 24 * 60 * 60 * 1000;
const validatePeriod = ({ min, max, start, end, }) => {
    const minDate = (0, get_number_of_days_1.getNumberOfDays)(min) || 0;
    const maxDate = (0, get_number_of_days_1.getNumberOfDays)(max) || 0;
    const timeDifference = Math.abs(new Date(start).getTime() - new Date(end).getTime());
    const differenceInDays = Math.floor(timeDifference / ONE_DAY) + 1;
    const res = minDate <= differenceInDays && differenceInDays <= maxDate;
    return res;
};
exports.validatePeriod = validatePeriod;
